import { get } from 'lodash';
import { http } from 'services';

export function getNutritionInformation(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/nutrition-information`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function saveNutritionInformation(type, id, data, cbSuccess, cbError) {
  http.patch(
    `${type}/${id}/nutrition-information`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function recreateNutritionInformation(type, id, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/recreate-nutrition-information`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getNutritionFacts(type, id, query, cbSuccess, cbError) {
  const responseType = get(query, 'file_format', null) !== null ? 'blob' : null;

  http.request(
    'get',
    `${type}/${id}/nutrition-facts`,
    query,
    null,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
    null,
    responseType,
  );
}

export function recreateNutritionFacts(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/recreate-nutrition-facts`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getNutritionFactsLabel(cbSuccess, cbError) {
  http.get(
    'settings/nutrition/facts-label',
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getNutritionPrediction(type, id, params, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/nutrition-prediction`,
    params,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-nutrition-information.js